import { Tooltip } from "@mui/material";

export const TextCardReadonlyData = [
  {
    id: 1,
    textValue:
      "Rosalind Franklin's contributions to the discovery of DNA structure remain one of the most compelling narratives in the annals of scientific research. Born in 1920 in London, Franklin was a gifted scientist whose work in X-ray crystallography was instrumental in understanding the molecular structure of DNA.\n\nFranklin's journey in science began at Cambridge University, where her passion for chemistry and physics blossomed. Her most significant work unfolded at King's College London, where she used X-ray diffraction methods to study DNA. Franklin's photographs, particularly Photo 51, revealed critical clues about DNA's structure. Her images showed DNA to be a double helix, a discovery that was pivotal to the work of James Watson and Francis Crick, who later won the Nobel Prize for this groundbreaking finding.\n\nDespite her crucial role, Franklin's contributions were overshadowed in a male-dominated field, and her work was only fully recognized posthumously. She faced gender-based discrimination, yet remained undeterred in her pursuit of scientific excellence. Franklin's dedication to her research was unwavering, even as she battled ovarian cancer, which tragically cut her life short at the age of 37.\n\nToday, Rosalind Franklin is celebrated as a pioneering figure in molecular biology. Her legacy lives on, not only in the realm of DNA research but also as an inspiration for women in science. She broke barriers and paved the way for future generations of female scientists, showing the world the invaluable contributions women can make in the field of science and research.\n\nIn conclusion, Rosalind Franklin's story is a poignant reminder of the unrecognized heroes of scientific discovery. Her determination, expertise, and significant findings in DNA structure have left an indelible mark on the world of science and medicine.",
  },
  {
    id: 2,
    textValue:
      "What are the potential negative impacts of multitasking on focus and performance?",
  },
  {
    id: 3,
    textValue:
      "You are a language school teacher and want to persuade more adults in your area to enroll in your courses. Write an email to the editor of the local newspaper, explaining three reasons why learning a foreign language benefits adults.\n\nYour reasons must be based on the following three themes:\n\n- Personal development\n\n- Career opportunities\n\n- Cultural awareness\n\nYou should include all three themes. Provide supporting examples for your reasons.",
  },
  {
    id: 4,
    textValue:
      "The German Luftwaffe dropped thousands of bombs on London from 1939 to 1945, killing almost 30,000 people. More than 70,000 buildings were completely demolished, and another 1.7 million were damaged.The extent of the damage to each and every one of these buildings was logged and mapped in near real-time by surveyors, architects, engineers, and construction workers.The result is an incredible collection of maps, color-coded by hand, that reveal the amount of the destruction in painstaking detail.Today, the maps remain an invaluable resource for academics, family historians, and even builders trying to avoid touching off unexploded bombs.\n\nNow, these bomb census maps are available in a beautiful oversized book released earlier this year to commemorate the 75th anniversary of the end of the Blitz, a nine-month period during which London and other British cities were relentlessly attacked by the German air force. Visually, the maps are quite striking. The apparent randomness of the colors stands in contrast to the more orderly pattern of streets and buildings. The damage from World War II transformed London into the architecturally diverse city it is today. The maps showing how widespread the destruction was, really bring home the scale of the devastation.",
  },
  {
    id: 5,
    textValue:
      "Drugs we take can weaken our bones and so can ageing, and scientists working to prevent both have some of the first evidence that the best target may not be the logical one. They are finding that in ageing bone, the mineralocorticoid receptor, better known for its role in blood pressure regulation, is a key factor in bone health, says Dr. Meghan E. McGee-Lawrence, biomedical engineer in the Department of Cellular Biology and Anatomy at the Medical College of Georgia. And drugs that block the receptor, like the hypertension medications spironolactone and eplerenone, may help protect bone cells.\n\nDrugs like prednisone are glucocorticoids, which are better known for their roles in reducing inflammation and suppressing the immune response, which is why they work so well for problems like irritable bowel syndrome and arthritis. But, like ageing, they can also disrupt the healthy, ongoing dynamic of bone being made and being destroyed. Our natural glucocorticoid levels increase with age, and bone, at least when we are young, has more glucocorticoid receptors than mineralocorticoid receptors. Glucocorticoids can actually coax stem cells to make bone-forming osteoblasts, but it also causes those osteoblasts to store more fat, and too much fat in the bone, like anywhere on our body, is probably not good and typically correlates with bone loss. So reducing the impact of glucocorticoid receptors seemed like a logical way to protect bone.",
  },
];

export const MCQsComponentData = [
  {
    id: 1,
    question:
      "Which of the following are mentioned as influences on the English landscape garden?",
    answers: [
      "A) Italian classical painting",
      "B) Gardens from classical Greece and Rome",
      "C) The Romantic Movement",
      "D) A person's political affiliations",
      "E) The poet Alexander Pope",
    ],
    render: "multiple",
    // pass prop 'single' to render single answer selection component
    // pass prop 'multiple to render multiple answer selection component
  },

  {
    id: 2,
    question:
      "Which of the following most accurately summarizes the opinion of the author in the text?",
    answers: [
      "A) The author believes that the maps are an accurate representation of post-war London.",
      "B) The author believes that the maps are works of art that give information about London’s destruction in World War II.",
      "C) The author believes that the maps are a beautiful and accurate representation of pre-war London.",
      "D) The author believes that the maps are a valuable piece of World War II history.",
    ],
    render: "single",
  },
  {
    id: 3,
    question: "Which of the following statements are true?",
    answers: [
      "A) Ageing can weaken our bones.",
      "B) Glucocorticoids work so bad for arthritis.",
      "C) Bone cells may be protected by drugs that block receptors.",
      "D) Augmenting the effect of glucocorticoid receptor must be a reasonable way to protect bone.",
      "E) When we are young, there are fewer mineralocorticoid receptors in the brain than glucocorticoid receptors.",
    ],
    render: "multiple",
    // pass prop 'single' to render single answer selection component
    // pass prop 'multiple to render multiple answer selection component
  },
  // Highlight incorrect Summary
  {
    id: 4,
    question:
      "Which of the following most accurately summarizes the opinion of the author in the text?",
    answers: [
      "A) The study of family history began hundreds of years ago in North Africa in order to establish such things as ownership of property. It rapidly became a common practice in many cultures because inheritance played such an important role in society and government.",
      "B) Research into family history by ordinary people only started to become far more widespread in the early nineteenth century. Prior to that time, it was chiefly rich. important and powerful families who had an interest and involvement in this type of activity.",
      "C) All social classes of the general population have always been interested in recording their family history. but genealogy became really popular in the early nineteenth century due to the publication of a book concerning the methodology of determining family history.",
      "D) Originally. tracing family history was only used in order to establish the origins of prosperous and powerful families. However. by the middle of the twentieth century. ordinary people were also starting to show an interest in researching their family background too.",
    ],
    render: "single",
    // pass prop 'single' to render single answer selection component
    // pass prop 'multiple to render multiple answer selection component
  },
];

export const AiScoreCardSWTData = [
  {
    id: 1,
    EnableSkills: [
      { component: "Content", score: "2/3", suggestion: "Great!" },
      {
        component: "Form",
        score: "2/2",
        suggestion:
          "SWT answer can only have 1 sentence. You have 3 sentences in your answer. 0 for form and no further scoring.",
      },
      {
        component: "Grammar",
        score: "1/2",
        suggestion: "Wrong form. No scoring",
      },
      {
        component: "Vocabulary",
        score: "2/4",
        suggestion: "Wrong form. No scoring",
      },
    ],
    SmallScoreCard: [
      [
        {
          HeaderBgColor: "#ff5d5d",
          Heading: "Score",
          score: "7",
          totalScore: "7",
          progressColorFilled: "#FF5D5D",
          progressColorUnfilled: "#E5DAFF",
        },
      ],
      [
        {
          HeaderBgColor: "#ff5d5d",
          Heading: "Writing",
          score: "7",
          totalScore: "7",
          progressColorFilled: "#FF5D5D",
          progressColorUnfilled: "#E5DAFF",
        },
      ],
    ],
    UserResponse: {
      textValue:
        "Rosalind Franklin's from Cambridge University had passion for chemistry and physics. At King's College London, she used X-ray diffraction method to studt DNA. Het photo 51, revealed clues about DNA structure.Her discovery shows double helix discovery that was pivotal to the work of James Watson and Francis Crick. Her contributions were overtaken by male dominated field whereby her work wad not fully recognised. Faced with gender discrimination she remained stern to persue.",
    },
  },
];

export const AiScoreCardWriteEssayData = [
  {
    id: 1,
    EnableSkills: [
      { component: "Content", score: "2/3", suggestion: "Great!" },
      {
        component: "Form",
        score: "2/2",
        suggestion: "Great Form",
      },
      {
        component: "Grammar",
        score: "1/2",
        suggestion: "Great grammar!",
      },
      {
        component: "Spelling",
        score: "1/2",
        suggestion: "Great spelling!",
      },
      {
        component: "Vocabulary Range",
        score: "2/4",
        suggestion: "Great! A good range of vocabulary is used.",
      },
      {
        component: "General linguistic range",
        score: "2/4",
        suggestion: "Good! Various sentence structures are used.",
      },
      {
        component: "Development, structure and coherence",
        score: "2/4",
        suggestion: "Great! Clear essay structure.",
      },
    ],
    SmallScoreCard: [
      {
        HeaderBgColor: "#ff5d5d",
        Heading: "Score",
        score: "12",
        totalScore: "26",
        progressColorFilled: "#FF5D5D",
        progressColorUnfilled: "#E5DAFF",
      },
    ],
    UserResponse: {
      textValue:
        "Rosalind Franklin's contributions to the discovery of DNA structure remain one of the most compelling narratives in the annals of scientific research. Born in 1920 in London, Franklin was a gifted scientist whose work in X-ray crystallography was instrumental in understanding the molecular structure of DNA.\n\nFranklin's journey in science began at Cambridge University, where her passion for chemistry and physics blossomed. Her most significant work unfolded at King's College London, where she used X-ray diffraction methods to study DNA. Franklin's photographs, particularly Photo 51, revealed critical clues about DNA's structure. Her images showed DNA to be a double helix, a discovery that was pivotal to the work of James Watson and Francis Crick, who later won the Nobel Prize for this groundbreaking finding.\n\nDespite her crucial role, Franklin's contributions were overshadowed in a male-dominated field, and her work was only fully recognized posthumously. She faced gender-based discrimination, yet remained undeterred in her pursuit of scientific excellence. Franklin's dedication to her research was unwavering, even as she battled ovarian cancer, which tragically cut her life short at the age of 37.\n\nToday, Rosalind Franklin is celebrated as a pioneering figure in molecular biology. Her legacy lives on, not only in the realm of DNA research but also as an inspiration for women in science. She broke barriers and paved the way for future generations of female scientists, showing the world the invaluable contributions women can make in the field of science and research.\n\nIn conclusion, Rosalind Franklin's story is a poignant reminder of the unrecognized heroes of scientific discovery. Her determination, expertise, and significant findings in DNA structure have left an indelible mark on the world of science and medicine.",
    },
  },
];

export const AiScoreCardWriteEmailData = [
  {
    id: 1,
    EnableSkills: [
      { component: "Content", score: "2/3", suggestion: "Great!" },
      {
        component: "Form",
        score: "2/2",
        suggestion: "Great Form",
      },
      {
        component: "Grammar",
        score: "1/2",
        suggestion: "Great grammar!",
      },
      {
        component: "Spelling",
        score: "1/2",
        suggestion: "Great spelling!",
      },
      {
        component: "Vocabulary Range",
        score: "2/4",
        suggestion: "Great! A good range of vocabulary is used.",
      },
      {
        component: "General linguistic range",
        score: "2/4",
        suggestion: "Good! Various sentence structures are used.",
      },
      {
        component: "Development, structure and coherence",
        score: "2/4",
        suggestion: "Great! Clear essay structure.",
      },
    ],
    SmallScoreCard: [
      {
        key: "Score",
        HeaderBgColor: "#ff5d5d",
        Heading: "Score",
        score: "14",
        totalScore: "15",
        progressColorFilled: "#FF5D5D",
        progressColorUnfilled: "#E5DAFF",
      },
    ],
    UserResponse: {
      textValue:
        "Hi John,\n\nAssume you are busy with party arrangements for next Saturday. So, I'll keep this email very short. Thank you for the invitation to your home coming party. It would have been fun to join you all on a Saturday night.\n\nUnfortunately, I have to complete my homework through this weekend, It'll take some time to finish and I might not be able to join you on the day.\n\nHave a great party on this weekend and let's hangout on next Friday at your place with Jack and Jill. I'll bring a few beers and a bite to eat.\n\nYours,\n\nGeorge.",
    },
  },
];

export const highlightWords = (text, words, indexes, tooltipHeading) => {
  let currentIndex = 0;
  const elements = [];

  for (let i = 0; i < indexes.length; i++) {
    const word = words[i];
    const [start, end] = indexes[i];

    const beforeSpace = start > 0 && /\s/.test(text[start - 1]);
    const afterSpace = end < text.length && /\s/.test(text[end]);

    const adjustedStart = beforeSpace ? start - 1 : start;
    const adjustedEnd = afterSpace ? end + 1 : end;

    elements.push(
      <span
        key={`text-${i}`}
        dangerouslySetInnerHTML={{
          __html: text.substring(currentIndex, adjustedStart),
        }}
      />
    );

    elements.push(
      <Tooltip title={`${tooltipHeading[i]}`}>
        <span
          style={{ color: "red", cursor: "pointer" }}
          dangerouslySetInnerHTML={{
            __html:
            text.substring(adjustedStart, adjustedEnd),
          }}
        />
      </Tooltip>
    );

    currentIndex = adjustedEnd;
  }

  elements.push(
    <span
      key="last-part"
      dangerouslySetInnerHTML={{ __html: text.substring(currentIndex) }}
    />
  );

  return elements;
};

export const EmailScoreCard = [
  {
    HeaderBgColor: "#ff5d5d",
    Heading: "Score",
    score: "12",
    totalScore: "15",
    progressColorFilled: "#FF5D5D",
    progressColorUnfilled: "#E5DAFF",
  },
];
